import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {MessageService} from "primeng/components/common/messageservice";
import {Observable} from "rxjs/Observable";

export class CommonHttpInterceptor implements HttpInterceptor {

  constructor(private messageService: MessageService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).do((event: HttpEvent<any>) => {
    }, (error: HttpErrorResponse) => {
      if (error.status === 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error de conexión',
          detail: 'Por favor revisa tu conexión a internet'
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/common-http.interceptor.ts